import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Checkbox, message, Modal, Alert, Space, Select } from 'antd';

import { ExclamationCircleOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { logout, updateGlobalSearch, selectPage, requestServerPost } from '../../actions';
import PopupManager from '../../managers/PopupManager';
import ReactPlayer from 'react-player';

const { Option } = Select;
const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};
const formTailLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18, offset: 6 },
};

const CreateURLMediaView = (props) => {
    const [form] = Form.useForm();
    const [fileData, setFileData] = useState(null)
    const [initialV, setInitialV] = useState({})
    const [errorMessage, setErrorMessage] = useState(null);
    const [accessBranches, setAccessBranches] = useState(["all"]);
    const { requestServerPost, usertoken, selectedBrandData, selectedBranchData, data = null, type = "web", branches = [], allBranchesOption = true, initialAccessBranches = ["all"] } = props;
    useEffect(() => {
        if ("data" in props && props.data) {
            console.log("data " + JSON.stringify(props.data))
            const datatype = props.data.FileType?.toLocaleLowerCase()

            if (datatype === "web" || datatype === "videourl") {

                const initial = {
                    medianame: props.data.FileName,
                    url: props.data.UploadFile
                }
                console.log("initial " + JSON.stringify(initial))

                form.setFieldsValue(initial)

                setFileData(props.data)
                setInitialV(initial)

                // Initialize accessBranches from existing media data
                const ab = props.data.AccessBranches;
                if (ab && ab !== "null" && ab !== "all" && ab !== "") {
                    setAccessBranches(ab.split(',').map(id => String(id).trim()).filter(Boolean));
                } else {
                    setAccessBranches(["all"]);
                }
            }

        }
    }, [])

    // When branches load (async), apply the folder-based default in create mode
    useEffect(() => {
        if (!data) {
            setAccessBranches(initialAccessBranches);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [branches])

    function validURL(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }

    const onFinish = async values => {

        var params = {};

        params["brandid"] = selectedBrandData.BrandID;
        params["urlname"] = values.medianame;
        params["url"] = values.url;
        params["accessbranches"] = accessBranches.includes("all") ? "all" : accessBranches.join(",");
        // When All Branches is hidden (folder-restricted), expand "all" to the explicit branch IDs
        if (!allBranchesOption && params["accessbranches"] === "all" && branches.length > 0) {
            params["accessbranches"] = branches.map(b => String(b.BranchID)).join(",");
        }
        if (selectedBrandData?.ContentSharingMode == 2 && selectedBranchData) {
            params["accessbranches"] = String(selectedBranchData.BranchID);
        }

        let update_action = "update_weburl";
        let create_action = "create_weburl";

        if (type == "videourl") {

            update_action = "update_videourl";
            create_action = "create_videourl";
        }

        if (fileData) {
            params["fileid"] = fileData.FileID;
            requestServerPost(update_action, params, {  }, (response) => {

                PopupManager.closePopup();
            }, usertoken);
        }
        else {
            requestServerPost(create_action, params, {  }, (response) => {

                PopupManager.closePopup();
            }, usertoken);
        }
    };

    const onCreate = async () => {
        try {
            const values = await form.validateFields();
            // console.log('Success:', values);
        } catch (errorInfo) {
            // console.log('Failed:', errorInfo);
        }
    };

    const onURLChanged = (evt) => {
        const url = evt.target.value
        const isURLValid = validURL(url)

        if (!isURLValid) {
            setErrorMessage('The inputted URL might be invalid');
        }
        else if (type == "videourl") {
            const canplay = ReactPlayer.canPlay(url);
            if (!canplay) {

                setErrorMessage('The inputted URL might not be playable');
            }
            else {
                setErrorMessage(null)
            }
        }
        else {
            setErrorMessage(null)
        }

        // if (type == "videourl") {
        //     const canplay = ReactPlayer.canPlay(url);
        //     if (!canplay) {

        //         setErrorMessage('The inputted URL might not be playable, do you want to continue?');
        //     }
        // }

    }

    let name_label = "Webiste Name";
    let name_message = 'Website name is required';
    let name_instruction = 'Input the name of your website';

    if (type == "videourl") {
        name_label = "Video URL Name";
        name_message = 'Video URL name is required';
        name_instruction = 'Input the name of your Video URL';
    }

    const handleAccessBranchesChange = (value) => {
        let newVal;
        if (value.includes("all") && !accessBranches.includes("all")) {
            newVal = ["all"];
        } else if (accessBranches.includes("all") && value.length > 1) {
            newVal = value.filter(v => v !== "all");
        } else if (value.length === 0) {
            newVal = ["all"];
        } else {
            newVal = value;
        }
        setAccessBranches(newVal);
    };

    return (
        <Form form={form} initialValues={initialV} onFinish={onFinish} name="dynamic_rule" style={{ width: "100%" }}>
            {(type == "videourl") &&
                <Form.Item>
                    <Alert
                        message="Important : This media type only works with player version 0.1.12 and above"
                        type="info"
                    />
                </Form.Item>}
            <Form.Item

                {...formItemLayout}
                name="medianame"
                label={name_label}
                rules={[
                    {
                        required: true,
                        message: name_message,
                    },
                ]}
            >
                <Input placeholder={name_instruction} />
            </Form.Item>
            <Form.Item
                {...formItemLayout}
                name="url"
                label="URL"
                rules={[
                    {
                        required: true,
                        message: 'URL is required',
                    },
                ]}
            >
                <Input onChange={onURLChanged} placeholder="Input the URL path" />
            </Form.Item>
            {branches.length > 0 && (
                <Form.Item {...formItemLayout} label="Accessible Branches">
                    <Select
                        allowClear
                        mode="multiple"
                        style={{ width: "100%", border: "1.5px solid #ccc", borderRadius: "5px", overflow: "hidden" }}
                        value={accessBranches}
                        onChange={handleAccessBranchesChange}
                        maxTagCount="responsive"
                    >
                        {allBranchesOption && <Option key="all" value="all">All Branches</Option>}
                        {branches.map(b => (
                            <Option key={b.BranchID} value={String(b.BranchID)}>{b.BranchName}</Option>
                        ))}
                    </Select>
                </Form.Item>
            )}
            <Form.Item {...formTailLayout}>
            </Form.Item>
            <Form.Item {...formTailLayout}>
                {
                    errorMessage ? <Alert
                        message="Warning"
                        showIcon
                        description={errorMessage}
                        type="warning"
                        action={
                            <Space direction="vertical">
                                <Button onClick={() => { setErrorMessage(null) }} size="small" danger>
                                    Ignore Warning
                                </Button>
                            </Space>
                        }
                    /> : <Button type="primary" htmlType="submit">
                        {fileData ? "Save" : "Create"}
                    </Button>
                }


            </Form.Item>
        </Form >
    );
};


const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, globalSearch: state.globalSearch, selectedPage: state.selectedPage, selectedBrandData: state.selectedBrandData, selectedBranchData: state.selectedBranchData };
}

export default connect(mapStateToProps, { logout, selectPage, updateGlobalSearch, requestServerPost })(CreateURLMediaView);
